<template>
	<div class="dropdown" >
		<button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: .7rem;">
			{{ selected_index >= 0 ? arr_sort[selected_index].label : title_sort_by }}
		</button>

		<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
			<div v-for="(data, index) in arr_sort" :key="index">

				<a class="dropdown-item" style="font-size: .7rem;" :class="{ 'active': selected_index == index, }" href="#" v-on:click="() => selected_index = index">{{ data.label }}</a>
				<div class="dropdown-divider" v-show="data.showDivider"></div>
			</div>
			<!-- <a class="dropdown-item" href="#">Title A - Z</a>
			<a class="dropdown-item" href="#">Title Z - A</a>
			<div class="dropdown-divider"></div>
			<a class="dropdown-item" v-model="price_desc" href="#!" v-on:click="sort">Price High - Low</a>
			<a class="dropdown-item" v-model="price_asc" href="#!" v-on:click="sort">Price Low - High</a>
			<div class="dropdown-divider"></div>
			<a class="dropdown-item" href="#">Last Release</a> -->
		</div>
	</div>
</template>

<script>
	export default {
		props:[
		'title_sort_by', 'sort_by_related', 'sort_by_title_asc', 'sort_by_title_desc', 'sort_by_author_asc', 'sort_by_author_desc', 'sort_by_price_desc', 'sort_by_price_asc', 'sort_by_release', 'sort_data',
		],
		data(){
			return {
				arr_sort: [
					{
						data: 'name_asc',
						label: this.sort_by_title_asc,
					},
					{
						data: 'name_desc',
						label: this.sort_by_title_desc,
						showDivider: true,
					},
					{
						data: 'author_asc',
						label: this.sort_by_author_asc,
					},
					{
						data: 'author_desc',
						label: this.sort_by_author_desc,
						showDivider: true,
					},
					{
						data: 'price_desc',
						label: this.sort_by_price_desc
					},
					{
						data: 'price_asc',
						label: this.sort_by_price_asc,
						showDivider: true,
					},
					{
						data: 'last_release',
						label: this.sort_by_release
					},
				],
				selected_index: -1,
				from_system: false,
			}
		},
		watch: {
			sort_data(val){
				if(val.data != null){
					for(let x in this.arr_sort){
						if(this.arr_sort[x].data == val.data){
							this.from_system = true
							this.selected_index = x
							break
						}
					}
				}
			},
			selected_index(val){
				if(this.from_system){
					this.from_system = false
					return
				}

				this.$emit('sort', this.arr_sort[val])
			},
		},
		mounted(){
			if(this.sort_data.data != null){
				for(let x in this.arr_sort){
					if(this.arr_sort[x].data == this.sort_data.data){
						this.from_system = true
						this.selected_index = x
						break
					}
				}
			}
		}
	}
</script>
